var _path, _g, _rect, _rect2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdv3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_372_16129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 30,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.6574C6 11.1206 6.21578 10.6063 6.59882 10.2302L15.4165 1.57287C15.7905 1.20571 16.2936 1 16.8177 1H34C35.1046 1 36 1.89543 36 3V27C36 32.5228 31.5228 37 26 37H8C6.89543 37 6 36.1046 6 35V11.6574Z",
    fill: "#B3B2C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_372_16129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.6574C6 11.1206 6.21578 10.6063 6.59882 10.2303L15.4165 1.57287C15.7905 1.20571 16.2936 1 16.8177 1H34C35.1046 1 36 1.89543 36 3V31C36 34.3137 33.3137 37 30 37H8C6.89543 37 6 36.1046 6 35V11.6574Z",
    fill: "url(#paint0_linear_372_16129)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 5,
    width: 12,
    height: 12,
    fill: "#E5E4EC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 12,
    y: 18,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#E5E4EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 12,
    y: 23,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#E5E4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18C4.34315 18 3 19.3431 3 21V42C3 43.6569 4.34315 45 6 45H32.5V47H6C3.23858 47 1 44.7614 1 42V21C1 18.2386 3.23858 16 6 16V18Z",
    fill: "#F44519"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9214 43.7312L45.5282 24.3656C45.7859 23.7096 45.3023 23 44.5975 23H37.3546C36.8315 23 36.3292 23.205 35.9554 23.571L33.1815 26.2871C32.0601 27.3851 30.5532 28 28.9838 28H11.9424C11.119 28 10.3797 28.5047 10.0798 29.2716L4.46218 43.6358C4.20571 44.2916 4.68932 45 5.3935 45H36.0599C36.8822 45 37.6208 44.4966 37.9214 43.7312ZM11.9424 26C10.2956 26 8.817 27.0094 8.21718 28.5431L2.59956 42.9073C1.83013 44.8748 3.28097 47 5.3935 47H36.0599C37.7046 47 39.1817 45.9933 39.783 44.4624L47.3898 25.0968C48.1628 23.1288 46.7119 21 44.5975 21H37.3546C36.3083 21 35.3037 21.41 34.5561 22.142L31.7823 24.858C31.0347 25.59 30.03 26 28.9838 26H11.9424Z",
    fill: "#F44519"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_372_16129",
    x1: 10.4444,
    y1: 6.625,
    x2: 40.2546,
    y2: 36.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdv3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adv3.a914c21ae5dc6c668030710a87457688.svg";